import { Link } from "react-router-dom";
import Layout from "../../components/global/layout";
import "./profile.scss";
import methodModel from "../../methods/methods";
import { useSelector } from "react-redux";
import PhoneInput from "react-phone-input-2";
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react'
import { AiTwotoneEdit } from "react-icons/ai";
import { useState } from "react";
import { LuUser2 } from "react-icons/lu";
import { MdPassword } from "react-icons/md";
import ChangePassword from "../../components/Profile/ChangePassword";
import EditProfile from "../../components/Profile/Edit";
import { FaEdit } from "react-icons/fa";


const Profile = () => {
  const user = useSelector((state: any) => state.user);
  const [activeTab, setActiveTab] = useState(0);

const [EditTabSet,setEditTabSet]=useState(false);
  return (
    <Layout>
      <div className="wrapper_section pt-6">
       

        <div className="max-w-[1200px] mx-auto">


          <TabGroup>
          <TabList className="flex gap-2 flex-wrap mb-8">
        <Tab
          className={`${
            activeTab === 0 ? "bg-primary text-white" : "bg-[#F2F2F2] text-black"
          } px-4 py-2 rounded-full flex items-center gap-2 hover:oapcity-80 !outline-none`}
          onClick={() => setActiveTab(0)}
        >
         <LuUser2 />         Profile
        </Tab>
        <Tab
          className={` ${
            activeTab === 1 ? "bg-primary text-white" : "bg-[#F2F2F2] text-black"
          } px-4 py-2 rounded-full flex items-center gap-2 hover:oapcity-80 !outline-none`}
          onClick={() => setActiveTab(1)}
        >
         <MdPassword />         Change password
        </Tab>
      </TabList>
              <TabPanels className="">
                <TabPanel>
                { !EditTabSet?   <>      <div className="flex items-center justify-between gap-2 mb-5">
                  <h3 className=" text-lg lg:text-2xl font-semibold text-[#111827]">
                    Profile Information
                  </h3>
                   <p
                   onClick={e=>setEditTabSet(true)}
                   className=" flex items-center gap-1 hover:opacity-80 ml-auto cursor-pointer">
                   <span className='cursor-pointer rounded-full w-8 h-8 flex items-center justify-center text-lg hover:opacity-80 bg-[#F2F2F2] text-[#797979]'>
                    <FaEdit className='' /></span>
                    <p>Edit</p>
                                    </p>
                </div>

              <div className="flex max-lg:flex-wrap gap-5 sm:gap-8 bg-[#FAFAFA] rounded-[12px] p-5 sm:p-8">
                        <div className="w-full lg:max-w-[350px] w-full bg-white shadow-[0px_3px_14px_-8px_#888888] text-center rounded-[12px] p-5 sm:p-8">
                          <div className="relative w-fit h-fit mx-auto">
                        <img
                          src={user && user.image ? methodModel.userImg(user.image) : 'img/dummy-profile.jpg'}
                          className="w-28 h-28 mx-auto rounded-full border-4 border-[#CC9900] object-cover"
                        />
                        </div>
                         <div className="space-y-2 mt-4">
                          <h2 className="text-2xl font-bold text-gray-800">  {user && user?.fullName}</h2>
                          <p className="text-gray-500">  {user && user?.email}</p>
                         </div>
                        </div>
                        <div className="w-full bg-white shadow-[0px_3px_14px_-8px_#888888] rounded-[12px] p-5 sm:p-8">
                            <div className="grid grid-cols-12 gap-5">
                          <div className="col-span-12 sm:col-span-6">
                            <label className="block mb-2 text-sm font-medium text-gray-700">Name</label>
                            <p className="capitalize text-[13px] text-black bg-[#f5f5f5] min-h-[38px] rounded-md px-3 py-2">
                              {user && user?.fullName}
                            </p>
                          </div>
                          <div className="col-span-12 sm:col-span-6">
                            <label className="block mb-2 text-sm font-medium text-gray-700">Email</label>
                            <p className="text-[13px] text-black bg-[#f5f5f5] min-h-[38px] rounded-md px-3 py-2">
                              {user && user?.email}
                            </p>
                          </div>
                          <div className="col-span-12 sm:col-span-6">
                            <label className="block mb-2 text-sm font-medium text-gray-700">Mobile No</label>
                            <p className="form_controlinput">
                              {user?.mobileNo ?
                                <PhoneInput
                                  value={user?.mobileNo}
                                  disabled
                                />
                                : '--'}
                            </p>
                          </div>
                        </div>
                        </div>
                  </div>
                  </>:<EditProfile setEditTabSet={setEditTabSet}/>}


                </TabPanel>
                <TabPanel><ChangePassword/></TabPanel>
              </TabPanels>
          </TabGroup>



         
        </div>
      </div>
    </Layout>
  );
};

export default Profile;
